var map = {
	"./eduskills-input.db": [
		"./src/data/eduskills-input.db.json",
		"src_data_eduskills-input_db_json"
	],
	"./eduskills-input.db.json": [
		"./src/data/eduskills-input.db.json",
		"src_data_eduskills-input_db_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./src/data lazy recursive ^\\.\\/.*$";
module.exports = webpackAsyncContext;